import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import ScrollDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, IconButton, Paper, TextField, Typography } from "@mui/material";
import DOMPurify from "dompurify";

import profileLogo from "../../../asset/images/profileLogo.png";
import MessageAIComponent from "./MessageAIComponent";

export const PGUAssistantBotUI = (props) => {
  const {
    isMobile,
    chatRef,
    isExpanded,
    showScrollDown,
    inputMessage,
    aiIsGenerating,
    handleSendInputMessage,
    setInputMessage,
    messages,
    handleClose,
    handleDestroy,
    isRecording,
    speechSupported,
    startRecording,
    stopRecording,
    token
  } = props;

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        ...(!isExpanded && { display: "none" }),
      }}
    >
      {/* Agent Info */}
      <Box
      sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
          backgroundColor: "white",
        }}
      >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          padding: "6px",
          backgroundColor: "white",
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "8px",
            backgroundColor: "#f5f5f5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={profileLogo}
            alt="Agent"
            style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
            }}
          />
        </Box>
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 500, color: "#333" }}>
            TijarIA
          </Typography>
          <Typography variant="caption" sx={{ color: "#999" }}>
            IA Trade Assistant
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton size="small" sx={{ color: "#666" }} onClick={handleClose}>
            <RemoveIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" sx={{ color: "#666" }} onClick={handleDestroy}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      {/* Chat Messages */}
      <Paper
        elevation={0}
        ref={chatRef}
        sx={{
          flex: 1,
          overflow: "auto",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ccc",
            borderRadius: "3px",
          },
          scrollBehavior: "smooth",
          backgroundColor: "#f5f5f5",
          padding: 2,
        }}
      >
        {messages.map((message, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: message.sender === "user" ? "flex-end" : "flex-start",
              mb: 2,
            }}
          >
            {/* Timestamp */}
            {/* <Typography
              variant="caption"
              sx={{
                color: "#999",
                fontSize: "11px",
                mb: 0.5,
                display: "flex",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  backgroundColor:
                    message.sender === "user" ? "#E82930" : "#4CAF50",
                }}
              />
              Utilisateur{" "}
              {new Date().toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Typography> */}

            <Box
              sx={{
                maxWidth: "75%",
                padding: "12px 16px",
                borderRadius: "8px",
                backgroundColor:
                  message.sender === "user" ? "#E82930" : "white",
                color: message.sender === "user" ? "white" : "#333",
                boxShadow:
                  message.sender !== "user"
                    ? "0 1px 3px rgba(0,0,0,0.1)"
                    : "none",
              }}
            >
              {message.sender === "user" ? (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(message.text.replace(/\n/g, "<br />")),
                  }}
                />
              ) : (
                <MessageAIComponent message={message} />
              )}
            </Box>

            {/* Read status for user messages */}
            {/* {message.sender === "user" && (
              <Typography
                variant="caption"
                sx={{
                  color: "#999",
                  fontSize: "10px",
                  mt: 0.5,
                }}
              >
                Read
              </Typography>
            )} */}
          </Box>
        ))}
      </Paper>

      {/* Scroll Down Button */}
      {showScrollDown && (
        <Box
          sx={{
            position: "absolute",
            bottom: 85,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 10,
          }}
        >
          <IconButton
            onClick={() => {
              if (chatRef.current) {
                chatRef.current.scrollTop = chatRef.current.scrollHeight;
              }
            }}
            sx={{
              backgroundColor: "white",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <ScrollDownIcon sx={{ fontSize: 24, color: "#666" }} />
          </IconButton>
        </Box>
      )}

      {/* Input Area */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          padding: "12px 16px",
          backgroundColor: "white",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <TextField
          fullWidth
          name="message"
          multiline
          maxRows={4}
          variant="standard"
          placeholder="Comment je peux vous aider ?"
          value={inputMessage}
          onChange={(e) => {
            setInputMessage(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.shiftKey) {
              setInputMessage((prevInput) => prevInput + "\n");
              e.preventDefault();
            } else if (e.key === "Enter") {
              handleSendInputMessage();
              e.preventDefault();
            }
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: "14px",
              color: "#333",
            },
          }}
          sx={{
            "& .MuiInputBase-root": {
              padding: 0,
            },
          }}
        />
        {/*<IconButton size="small" sx={{ color: "#999" }}>
          <Typography sx={{ fontSize: "20px", transform: "rotate(45deg)" }}>
            📎
          </Typography>
        </IconButton>*/}
        {speechSupported && (
          <IconButton
            onClick={isRecording ? stopRecording : startRecording}
            sx={{
              color: isRecording ? "#f44336" : "#666",
              backgroundColor: isRecording
                ? "rgba(244, 67, 54, 0.1)"
                : "transparent",
              marginRight: "8px",
              position: "relative",
              animation: isRecording ? "pulse 1.5s infinite" : "none",
              "&::before": isRecording
                ? {
                    content: '""',
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "rgba(244, 67, 54, 0.3)",
                    borderRadius: "50%",
                    transform: "translate(-50%, -50%)",
                    animation: "ripple 1.5s infinite",
                    zIndex: -1,
                  }
                : {},
            }}
          >
            {isRecording ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M6 6h12v12H6z" />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
              </svg>
            )}
          </IconButton>
        )}
        <IconButton
          onClick={handleSendInputMessage}
          disabled={!inputMessage.trim() || aiIsGenerating}
          sx={{
            color: inputMessage.trim() && !aiIsGenerating ? "#4CAF50" : "#ccc",
            transition: "color 0.2s",
          }}
        >
          <Typography sx={{ fontSize: "20px", transform: "rotate(-45deg)" }}>
            ➤
          </Typography>
        </IconButton>
      </Box>
    </Box>
  );
};
